import { useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'

import Toggles from '@domain/toggles/Toggles'
import { setFormValidationMessages } from '@/utils'
import { i18nService } from '@/services'
import { LANGUAGE_CODES_LOCALE } from '@/constants'

const IntlWrapper = (props) => {
	const { children, language } = props

	const [defaultMessages, setDefaultMessages] = useState({})
	const [messages, setMessages] = useState(null)
	const [locale, setLocale] = useState(LANGUAGE_CODES_LOCALE[language])

	useEffect(() => {
		;(async () => {
			Promise.all([
				i18nService.fetchFrontTranslations(language),
				i18nService.fetchEprojectTranslations(language),
				i18nService.fetchWidgetsTranslations(language)
			]).then(res => {
				setDefaultMessages( res.reduce((messages, { data: m }) => ({ ...messages, ...m }), {}) )
			})
			setFormValidationMessages()
		})()
	}, [])

	useEffect(() => {
		;(async () => {
			Promise.all([
				i18nService.fetchFrontTranslations(language),
				i18nService.fetchEprojectTranslations(language),
				i18nService.fetchWidgetsTranslations(language)
			]).then(res => {
				setMessages( res.reduce((messages, { data: m }) => ({ ...messages, ...m }), defaultMessages) )
			})
			setLocale(LANGUAGE_CODES_LOCALE[language])
		})()
	}, [language])

	return messages ? (
		<IntlProvider messages={messages} locale={locale} onError={(error) => {
			if (Toggles.isEnabled('customTabsNameBySubfamilyInProductSheetWidget') && /productSheetWidget\.[0-9]+\.mainTabs\.tab/.test(error.message)) {
				return
			}
			console.error(error)
		}}>
			{children}
		</IntlProvider>
	) : null
}

export { IntlWrapper }
